module.exports = __webpack_public_path__ + "2e1610fab218a5454fcb02fa2dcc49fb.MP3";